/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubstituteRegulationSettingTodoInfo { 
    substituteRegulationSettingId?: number;
    principalDepartmentName?: string;
    principalJobTitleName?: string;
    principalDepartmentLevel?: number;
    applicant?: string;
    enableDate?: Date;
    processId?: string;
    taskId?: string;
    processDefKey?: string;
    /**
     * 狀態
     */
    statusCode?: string;
    createTime?: Date;
}